import { render } from "./TestTippy.vue?vue&type=template&id=72977063"
import script from "./TestTippy.vue?vue&type=script&lang=js"
export * from "./TestTippy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tooltips/TestTippy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72977063"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72977063', __exports__)) {
    api.reload('72977063', __exports__)
  }
  
  module.hot.accept("./TestTippy.vue?vue&type=template&id=72977063", () => {
    api.rerender('72977063', render)
  })

}


export default __exports__